import React from "react";
import {
  Box,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { Pencil, Trash2 } from "lucide-react";

export default function AgentsTable({ agents, onEdit, onDelete }) {
  return (
    <Paper sx={{ borderRadius: "12px", border: "1px solid #e5e7eb", boxShadow: "none", overflow: "hidden" }}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ "& th": { fontWeight: 700, color: "#6b7280", bgcolor: "#f9fafb" } }}>
              <TableCell>Agent</TableCell>
              <TableCell>User ID</TableCell>
              <TableCell>Contact</TableCell>
              <TableCell>Team</TableCell>
              <TableCell>Shift</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!agents.length && (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 5, color: "#9ca3af" }}>
                  No agents yet. Use "Create Agent" to add the first one.
                </TableCell>
              </TableRow>
            )}
            {agents.map((a) => (
              <TableRow key={a.id} hover>
                <TableCell>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: "#111827" }}>
                    {a.name || "--"}
                  </Typography>
                  {a.employeeCode && (
                    <Typography variant="caption" sx={{ color: "#9ca3af" }}>
                      {a.employeeCode}
                    </Typography>
                  )}
                </TableCell>
                <TableCell sx={{ fontFamily: "ui-monospace, Menlo, monospace" }}>{a.userid}</TableCell>
                <TableCell>
                  <Typography variant="caption" sx={{ display: "block", color: "#6b7280" }}>
                    {a.email || "--"}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#9ca3af" }}>
                    {a.phone || ""}
                  </Typography>
                </TableCell>
                <TableCell sx={{ color: "#6b7280" }}>{a.team || "--"}</TableCell>
                <TableCell sx={{ color: "#6b7280" }}>
                  {a.shiftStart ? `${a.shiftStart} - ${a.shiftEnd || "--"}` : "--"}
                </TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={a.status === "active" ? "Active" : "Inactive"}
                    sx={{
                      bgcolor: a.status === "active" ? "#ecfdf5" : "#f3f4f6",
                      color: a.status === "active" ? "#059669" : "#6b7280",
                      fontWeight: 600,
                    }}
                  />
                </TableCell>
                <TableCell align="right">
                  <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.5 }}>
                    <Tooltip title="Edit agent">
                      <IconButton size="small" onClick={() => onEdit(a)} sx={{ color: "#0C237B" }}>
                        <Pencil size={16} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Remove agent">
                      <IconButton size="small" onClick={() => onDelete(a)} sx={{ color: "#dc2626" }}>
                        <Trash2 size={16} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
